import * as React from "react";
import { ReactNode } from "react";
import styles from "./NavigationButton.module.css";
import { MediumIcon } from "../../../icons/IconSizes";
import { Icon } from "../icon/Icon";
import { AnchorElementProps, Column, Row, Text } from "@stenajs-webui/core";
import { CircledIcon } from "../icon/CircledIcon";
import { stenaAngleRight } from "../../../icons/generated/ArrowIcons";
import cx from "classnames";

export interface NavigationButtonProps extends AnchorElementProps {
  icon?: MediumIcon;
  label: string;
  description?: string;
  rightContent?: ReactNode;
  render?: (props: AnchorElementProps) => ReactNode;
}

export const NavigationButton: React.FC<NavigationButtonProps> = ({
  icon,
  label,
  className,
  description,
  rightContent,
  render,
  ...aProps
}) => {
  const children = (
    <Row alignItems={"center"} justifyContent={"space-between"} flex={1}>
      <Row gap={2} alignItems={"center"}>
        {icon && <CircledIcon icon={icon} size={"medium"} />}
        <Column gap={0}>
          <Text variant={"bold"}>{label}</Text>
          {description && <Text>{description}</Text>}
        </Column>
      </Row>
      <Row gap={2} alignItems={"center"}>
        {rightContent}
        <Icon icon={stenaAngleRight} size={24} />
      </Row>
    </Row>
  );

  if (render) {
    return render({
      ...aProps,
      className: cx(styles.navigationButton, className),
      children,
    });
  }

  return (
    <a className={styles.navigationButton} {...aProps}>
      {children}
    </a>
  );
};
